import { SERVICE_ACTIONS_ENUM } from "@/enums/gmb-services.enum";
import ItemIndexFinder from "@/helpers/gmbServices/item-index-finder";

class ServicePayloadBuilder {
  constructor(servicesPayload) {
    this.servicesPayload = servicesPayload;
  }

  updateServicePayload(updateItem) {
    const {
      indexOfSelectedService,
      indexOfTemporaryService
    } = ItemIndexFinder.getPayloadItemIndex(
      this.servicesPayload,
      updateItem.item
    );

    const shouldDeleteTemporaryService =
      indexOfTemporaryService !== -1 &&
      (updateItem.action === SERVICE_ACTIONS_ENUM.DELETE || !updateItem.action);

    if (shouldDeleteTemporaryService) {
      this.removeService(indexOfTemporaryService);
    } else if (indexOfSelectedService !== -1) {
      this.replaceService(indexOfSelectedService, updateItem);
    } else if (indexOfTemporaryService !== -1) {
      this.replaceService(indexOfTemporaryService, updateItem);
    } else {
      this.addService(updateItem);
    }
  }

  removeService(index) {
    this.servicesPayload.splice(index, 1);
  }

  replaceService(index, updateItem) {
    this.servicesPayload.splice(index, 1, updateItem);
  }

  addService(updateItem) {
    this.servicesPayload.push(updateItem);
  }
}

export default ServicePayloadBuilder;
